import React, { useState, useEffect } from 'react';
import {
  Box, 
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  CardActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  ListItemSecondaryAction,
  Tooltip,
  Popover,
  DialogContentText,
  FormControlLabel,
  Switch,
  Menu,
  Tabs,
  Tab,
  Stepper,
  Step,
  StepLabel,
  StepContent
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PhoneIcon from '@mui/icons-material/Phone';
import LinkIcon from '@mui/icons-material/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloudIcon from '@mui/icons-material/Cloud';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import DublinTrunkManager from './DublinTrunkManager';

const PhoneNumbers = () => {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [purchaseDialog, setPurchaseDialog] = useState(false);
  const [assignDialog, setAssignDialog] = useState(false);
  const [phoneToDelete, setPhoneToDelete] = useState(null);
  const [phoneToAssign, setPhoneToAssign] = useState(null);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [purchaseStep, setPurchaseStep] = useState(1);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [countryMenuAnchor, setCountryMenuAnchor] = useState(null);
  const [numberType, setNumberType] = useState('mobile');
  const [livekitIntegrationDialog, setLivekitIntegrationDialog] = useState(false);
  const [phoneForLivekit, setPhoneForLivekit] = useState(null);
  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [loadingNumbers, setLoadingNumbers] = useState(false);
  const [purchasingNumber, setPurchasingNumber] = useState(false);
  const [updatePhoneDialog, setUpdatePhoneDialog] = useState(false);
  const [phoneToUpdate, setPhoneToUpdate] = useState(null);
  const [phoneDescription, setPhoneDescription] = useState('');
  const [originationDialog, setOriginationDialog] = useState(false);
  const [phoneForOrigination, setPhoneForOrigination] = useState(null);
  const [originationUrl, setOriginationUrl] = useState('');
  const [trunkDetails, setTrunkDetails] = useState(null);
  const [loadingTrunkDetails, setLoadingTrunkDetails] = useState(false);
  const [sipUriDialog, setSipUriDialog] = useState(false);
  const [sipUri, setSipUri] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [agentForSipUri, setAgentForSipUri] = useState(null);
  const [submittingSipUri, setSubmittingSipUri] = useState(false);
  const [forceDelete, setForceDelete] = useState(false);
  const [deletingPhone, setDeletingPhone] = useState(false);
  const [purchaseCompleted, setPurchaseCompleted] = useState(false);
  const [purchasedNumber, setPurchasedNumber] = useState(null);
  const [assigningAgent, setAssigningAgent] = useState(false);
  const [updatingPhone, setUpdatingPhone] = useState(false);
  const [updatingOrigination, setUpdatingOrigination] = useState(false);
  const [originationUrls, setOriginationUrls] = useState([]);
  const [creatingLivekit, setCreatingLivekit] = useState(false);
  const [updatingSipUri, setUpdatingSipUri] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [countryMenu, setCountryMenu] = useState(null);
  const [selectedNumberType, setSelectedNumberType] = useState('mobile');
  const [purchaseResult, setPurchaseResult] = useState({ success: null, message: '', details: '' });
  const [purchaseProgressOpen, setPurchaseProgressOpen] = useState(false);
  const [selectedPhone, setSelectedPhone] = useState(null);
  const [sipUriValue, setSipUriValue] = useState('');
  const [priorityValue, setPriorityValue] = useState(10);
  const [weightValue, setWeightValue] = useState(10);
  const [friendlyName, setFriendlyName] = useState('');
  const [loadingOriginationUpdate, setLoadingOriginationUpdate] = useState(false);
  const [trunkSid, setTrunkSid] = useState('');
  const [showForceDelete, setShowForceDelete] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const [trunkToEditSip, setTrunkToEditSip] = useState(null);
  const [newSipUri, setNewSipUri] = useState('');
  const [newSipFriendlyName, setNewSipFriendlyName] = useState('');
  const [agentSipUri, setAgentSipUri] = useState('');
  const [savingSipUri, setSavingSipUri] = useState(false);
  const [purchaseAfterSipUri, setPurchaseAfterSipUri] = useState(false);
  const [assigningPhone, setAssigningPhone] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [purchaseSteps, setPurchaseSteps] = useState([
    { title: 'Select Country', completed: false, current: true },
    { title: 'Select Number', completed: false, current: false },
    { title: 'Assign Agent', completed: false, current: false },
    { title: 'Complete Purchase', completed: false, current: false }
  ]);
  
  // Dublin trunk related state variables
  const [dublinDialog, setDublinDialog] = useState(false);
  const [phoneToDublin, setPhoneToDublin] = useState(null);
  const [dublinSipUri, setDublinSipUri] = useState('');
  const [dublinFriendlyName, setDublinFriendlyName] = useState('AIForce Dublin Trunk');
  const [creatingDublinTrunk, setCreatingDublinTrunk] = useState(false);
  const [creatingLivekitIntegration, setCreatingLivekitIntegration] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [dublinTrunks, setDublinTrunks] = useState([]);
  const [loadingDublinTrunks, setLoadingDublinTrunks] = useState(false);
  const [selectedTrunk, setSelectedTrunk] = useState(null);
  const [trunkDetailsDialog, setTrunkDetailsDialog] = useState(false);
  const [phoneToConnectDialog, setPhoneToConnectDialog] = useState(false);
  const [selectedPhoneToConnect, setSelectedPhoneToConnect] = useState(null);
  const [trunkToConnect, setTrunkToConnect] = useState(null);
  const [connectingPhone, setConnectingPhone] = useState(false);
  
  // Add state variables for the transfer dialog
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [phoneToTransfer, setPhoneToTransfer] = useState('');
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);
  const [transferToUser, setTransferToUser] = useState('');
  const [transferringPhone, setTransferringPhone] = useState(false);
  
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const API_PATH = `${API_URL}/api`;
  const { user, isAdmin, token: auth } = useAuth();
  
  console.log('PhoneNumbers component - Auth state:', { 
    hasUser: !!user, 
    isAdmin, 
    userRole: user?.role,
    userIsAdmin: user?.is_admin
  });

  useEffect(() => {
    fetchPhoneNumbers();
    fetchAgents();
  }, []);

  useEffect(() => {
    // This effect runs when the purchaseDialog state changes
    if (purchaseDialog) {
      console.log('Purchase dialog opened - resetting states and fetching countries');
      // Reset states if dialog is opened
      setCountries([]);
      setSelectedCountry('');
      setSelectedNumber(null);
      setSelectedAgent('');
      setAvailableNumbers([]);
      
      // Fetch countries
      fetchCountries();
    }
  }, [purchaseDialog]);

  const fetchPhoneNumbers = async () => {
    try {
      setLoading(true);
      
      const response = await fetch(`${API_PATH}/didww/numbers`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const responseData = await response.json();
        console.log('Phone numbers loaded:', responseData);
        
        // Check if data exists and is an array - numbers are in responseData.numbers
        if (responseData.success && Array.isArray(responseData.numbers)) {
          // Sort phone numbers
          const sortedNumbers = responseData.numbers.sort((a, b) => {
            // Sort by owner first (for admins)
            if (a.owner_email && b.owner_email && a.owner_email !== b.owner_email) {
              return a.owner_email.localeCompare(b.owner_email);
            }
            // Then by phone number
            const aPhone = a.phone_number || a.phoneNumber;
            const bPhone = b.phone_number || b.phoneNumber;
            return aPhone.localeCompare(bPhone);
          });
          
          setPhoneNumbers(sortedNumbers);
        } else {
          // Handle case where data is not an array
          console.warn('Response data is not in the expected format:', responseData);
          setPhoneNumbers([]);
        }
      } else {
        console.error('Failed to fetch phone numbers:', await response.text());
        showSnackbar('Failed to fetch phone numbers', 'error');
      }
    } catch (error) {
      console.error('Error fetching phone numbers:', error);
      showSnackbar('Error fetching phone numbers', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchAgents = async () => {
    try {
      const response = await fetch(`${API_PATH}/agents`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });
      if (response.ok) {
        const data = await response.json();
        setAgents(data);
      }
    } catch (error) {
      console.error('Error fetching agents:', error);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Purchase phone number handlers
  const handleOpenPurchaseDialog = () => {
    // Just open the dialog, the useEffect will handle the rest
    console.log('handleOpenPurchaseDialog called - opening purchase dialog');
    setPurchaseDialog(true);
  };

  const openPurchaseDialog = () => {
    console.log('openPurchaseDialog called');
    handleOpenPurchaseDialog();
  };

  const handleClosePurchaseDialog = () => {
    setPurchaseDialog(false);
  };

  const fetchCountries = async () => {
    console.log('📞 fetchCountries: Starting to fetch countries');
    setLoadingCountries(true);
    setCountries([]);
    setSelectedCountry(''); // Reset selection when fetching countries
    
    try {
      console.log('📞 fetchCountries: Sending API request');
      const response = await fetch(`${API_PATH}/didww/countries`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('📞 fetchCountries: API response received', data);
        
        if (data.countries && data.countries.length > 0) {
          console.log(`📞 fetchCountries: Loaded ${data.countries.length} countries`);
          // Save the countries list to state
          setCountries(data.countries);
        } else {
          console.warn('📞 fetchCountries: No countries available or empty list returned');
          showSnackbar('No countries available', 'warning');
        }
      } else {
        console.error('📞 fetchCountries: Error response', response.status);
        showSnackbar('Error fetching countries', 'error');
      }
    } catch (error) {
      console.error('📞 fetchCountries: Network error', error);
      showSnackbar('Network error fetching countries', 'error');
    } finally {
      setLoadingCountries(false);
    }
  };

  // Add helper function to get country name from code
  const getCountryName = (code) => {
    const country = countries.find(c => c.code === code);
    return country ? `${country.name} (${code})` : code;
  };

  // Fix country menu handling
  const handleCountryMenuOpen = (event) => {
    setCountryMenu(event.currentTarget);
  };

  const handleCountryMenuClose = () => {
    setCountryMenu(null);
  };

  const handleSelectCountry = (code) => {
    console.log(`📞 handleSelectCountry: Selected country ${code}`);
    setSelectedCountry(code);
    handleCountryMenuClose();
    
    if (code) {
      fetchAvailableNumbers(code, 'mobile');
    } else {
      setAvailableNumbers([]);
    }
  };

  const handleAgentChange = (event) => {
    setSelectedAgent(event.target.value);
  };

  const handleSelectNumberType = (event) => {
    const type = event.target.value;
    setSelectedNumberType(type);
    
    // Fetch numbers for the selected country and type
    if (selectedCountry) {
      fetchAvailableNumbers(selectedCountry, type);
    }
  };

  const fetchAvailableNumbers = async (country, numberType = 'mobile') => {
    if (!country) {
      console.log('Cannot fetch available numbers: No country selected');
      return;
    }
    
    console.log(`📞 fetchAvailableNumbers: Starting for country: ${country}, type: ${numberType}`);
    setLoadingNumbers(true);
    setAvailableNumbers([]);
    
    try {
      // Find the country ID from the selected country code
      const countryObj = countries.find(c => c.code === country);
      if (!countryObj || !countryObj.id) {
        console.error('Country not found or missing ID');
        showSnackbar('Invalid country selection', 'error');
        setLoadingNumbers(false);
        return;
      }
      
      // Use the country ID for the API request
      const url = `${API_PATH}/didww/available_numbers?countryId=${encodeURIComponent(countryObj.id)}&type=${numberType}`;
      console.log(`📞 fetchAvailableNumbers: Sending API request to ${url}`);
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('📞 fetchAvailableNumbers: API response received', data);
        
        if (data.numbers && data.numbers.length > 0) {
          console.log(`📞 fetchAvailableNumbers: Found ${data.numbers.length} numbers for ${countryObj.name}`);
          setAvailableNumbers(data.numbers);
        } else {
          console.log(`📞 fetchAvailableNumbers: No numbers found for ${countryObj.name}`);
          setAvailableNumbers([]);
          showSnackbar(`No phone numbers available for ${countryObj.name}`, 'info');
        }
      } else {
        console.log('📞 fetchAvailableNumbers: API returned error');
        const errorData = await response.json();
        console.error('Error response:', errorData);
        showSnackbar(errorData.error || 'Error fetching phone numbers', 'error');
        setAvailableNumbers([]);
      }
    } catch (error) {
      console.error('📞 fetchAvailableNumbers: Exception occurred', error);
      showSnackbar('Error fetching phone numbers', 'error');
      setAvailableNumbers([]);
    } finally {
      setLoadingNumbers(false);
    }
  };

  const handleSelectNumber = (number) => {
    // Normalize the phone number object to ensure consistent property names
    const normalizedNumber = {
      ...number,
      phoneNumber: number.phoneNumber || number.phone_number,
      phone_number: number.phone_number || number.phoneNumber,
      sid: number.sid || number.phoneSid || number.phoneNumber, // Fallback to phone number if SID not available
      did_group_id: number.did_group_id // Make sure to preserve this for DIDWW purchases
    };
    setSelectedNumber(normalizedNumber);
    console.log('Selected phone number:', normalizedNumber);
  };

  const handlePurchaseNumber = async () => {
    if (!selectedNumber) {
      showSnackbar('Please select a phone number', 'error');
      return;
    }
    
    setPurchasingNumber(true);
    // Reset purchase result and set purchase process stages
    setPurchaseResult({ success: null, message: '', details: '' });
    setPurchaseSteps([
      { label: 'Initiating purchase', completed: false, current: true },
      { label: 'Fetching number details', completed: false, current: false },
      { label: 'Creating order with DIDWW', completed: false, current: false },
      { label: 'Processing order', completed: false, current: false },
      { label: 'Confirming purchase', completed: false, current: false }
    ]);
    setPurchaseProgressOpen(true);
    
    try {
      // Create the request body for phone number purchase
      const requestBody = {
        id: selectedNumber.did_group_id || selectedNumber.id,
        phone_number: selectedNumber.phone_number || selectedNumber.phoneNumber,
        friendly_name: selectedNumber.friendly_name || `Phone Number ${selectedNumber.phone_number || selectedNumber.phoneNumber}`,
        setup_cost: selectedNumber.setup_cost || 0,
        monthly_cost: selectedNumber.monthly_cost || 0,
        country_code: selectedCountry
      };
      
      // Only include agentId if an agent was selected
      if (selectedAgent) {
        requestBody.agentId = selectedAgent;
      }
      
      console.log('Purchase request body:', requestBody);
      
      // Update progress - step 1 complete
      updatePurchaseStep(0, true, false);
      updatePurchaseStep(1, false, true);
      
      const response = await fetch(`${API_PATH}/didww/purchase`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      
      // Update progress - fetching details complete, creating order
      updatePurchaseStep(1, true, false);
      updatePurchaseStep(2, false, true);
      
      // Simulate a slight delay for better UX
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Update progress - creating order complete, processing
      updatePurchaseStep(2, true, false);
      updatePurchaseStep(3, false, true);
      
      // Add another slight delay for better UX
      await new Promise(resolve => setTimeout(resolve, 800));
      
      // Update progress - processing complete, confirming
      updatePurchaseStep(3, true, false);
      updatePurchaseStep(4, false, true);
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          // Final update - all steps complete
          updatePurchaseStep(4, true, false);
          
          // Show success in the progress dialog
          setPurchaseResult({
            success: true,
            message: `Successfully purchased ${selectedNumber.phone_number || selectedNumber.phoneNumber}`,
            details: data.message || 'Your number has been added to your account.'
          });
          
          // Refresh phone numbers after a short delay
          setTimeout(() => {
            fetchPhoneNumbers();
            handleClosePurchaseDialog();
            setPurchaseProgressOpen(false);
          }, 2000); // Show success for a moment before closing
        } else {
          // Show error in the progress dialog
          setPurchaseResult({
            success: false,
            message: data.error || 'Error purchasing phone number',
            details: 'Please try again or contact support if the issue persists.'
          });
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        
        // Check if we need to set a SIP URI for the agent
        if (response.status === 400 && errorData.needs_sip_uri) {
          setPurchasingNumber(false);
          setPurchaseProgressOpen(false);
          // Find the agent details
          const agent = agents.find(a => a.id === selectedAgent);
          setAgentForSipUri(agent);
          setSipUriDialog(true);
          setPurchaseAfterSipUri(true);
          return;
        }
        
        // Show error in the progress dialog
        setPurchaseResult({
          success: false,
          message: errorData.error || 'Error purchasing phone number',
          details: 'Server returned an error. Please try again or contact support.'
        });
      }
    } catch (error) {
      console.error('Error purchasing phone number:', error);
      
      // Show error in the progress dialog
      setPurchaseResult({
        success: false,
        message: 'Error purchasing phone number',
        details: error.message || 'An unexpected error occurred. Please try again.'
      });
    } finally {
      setPurchasingNumber(false);
    }
  };
  
  // Helper function to update purchase steps
  const updatePurchaseStep = (index, completed, current) => {
    setPurchaseSteps(prevSteps => {
      const newSteps = [...prevSteps];
      newSteps[index] = { ...newSteps[index], completed, current };
      return newSteps;
    });
  };

  // SIP Origination URI handlers
  const handleOpenOriginationDialog = (phoneNumber) => {
    setSelectedPhone(phoneNumber);
    setTrunkSid('');
    setOriginationUrls([]);
    setSipUriValue('');
    setPriorityValue(10);
    setWeightValue(10);
    setFriendlyName(`Origination URL for ${phoneNumber.phone_number}`);
    setOriginationDialog(true);
    
    // Fetch SIP trunk details if available
    fetchTrunkDetails(phoneNumber);
  };

  const fetchTrunkDetails = async (phoneNumber) => {
    try {
      // First try to fetch with trailing slash
      const response = await fetch(`${API_PATH}/api/sip-trunks/`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.trunks && data.trunks.length > 0) {
          // Use the first trunk for simplicity
          const trunk = data.trunks[0];
          setTrunkSid(trunk.sid);
          
          // Fetch origination URLs for this trunk
          fetchOriginationUrls(trunk.sid);
        } else {
          console.log('No SIP trunks available or empty response', data);
        }
      } else {
        console.error('Error fetching trunks:', response.status);
        showSnackbar('Could not retrieve SIP trunk details. Please try again later.', 'error');
      }
    } catch (error) {
      console.error('Error fetching trunks:', error);
      showSnackbar('Network error while fetching SIP trunk details', 'error');
    }
  };

  const fetchOriginationUrls = async (trunkSid) => {
    try {
      const response = await fetch(`${API_PATH}/api/sip-trunks/${trunkSid}/origination-urls/list`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.data) {
          setOriginationUrls(data.data);
          
          // If there's an existing origination URL, populate the form with its values
          if (data.data.length > 0) {
            const url = data.data[0];
            setSipUriValue(url.sip_url || '');
            setPriorityValue(url.priority || 10);
            setWeightValue(url.weight || 10);
            setFriendlyName(url.friendly_name || `Origination URL for ${selectedPhone?.phone_number}`);
          }
        } else {
          // Empty origination URLs is OK, we'll create a new one
          setOriginationUrls([]);
        }
      } else {
        console.error('Error fetching origination URLs:', response.status);
        showSnackbar('Could not retrieve origination URLs. Please try again later.', 'error');
      }
    } catch (error) {
      console.error('Error fetching origination URLs:', error);
      showSnackbar('Network error while fetching origination URLs', 'error');
    }
  };

  const handleCloseOriginationDialog = () => {
    setOriginationDialog(false);
    setSelectedPhone(null);
  };

  const handleUpdateOrigination = async () => {
    if (!selectedPhone) {
      showSnackbar('No phone number selected', 'error');
      return;
    }
    
    if (!sipUriValue) {
      showSnackbar('Please enter a SIP URI', 'error');
      return;
    }
    
    setLoadingOriginationUpdate(true);
    
    try {
      // Use the phone number-specific endpoint with proper URL encoding
      const phone_number = selectedPhone.phone_number.replace(/[^0-9+]/g, '');
      const response = await fetch(`${API_PATH}/api/sip-trunks/phone-number/${phone_number}/set-origination`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sip_url: sipUriValue,
          priority: parseInt(priorityValue),
          weight: parseInt(weightValue),
          friendly_name: friendlyName
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar(`Origination URL ${data.action} successfully`);
          handleCloseOriginationDialog();
        } else {
          showSnackbar(data.error || 'Error updating origination URL', 'error');
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        showSnackbar(errorData.error || 'Error updating origination settings', 'error');
      }
    } catch (error) {
      showSnackbar('Error updating origination settings', 'error');
      console.error(error);
    } finally {
      setLoadingOriginationUpdate(false);
    }
  };

  // Replace separate delete and release dialogs with a single dialog
  const handleOpenDeleteDialog = (phoneNumber) => {
    setPhoneToDelete(phoneNumber);
    setDeleteDialog(true);
    setShowForceDelete(false);
    setDeleteError('');
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialog(false);
    setPhoneToDelete(null);
    setShowForceDelete(false);
    setDeleteError('');
  };

  const handleDeletePhoneNumber = async (force = false) => {
    if (!phoneToDelete) {
      return;
    }
    
    setDeletingPhone(true);
    try {
      // Use the DIDWW endpoint with the correct parameter format
      const url = `${API_PATH}/didww/numbers/${phoneToDelete.did_id || phoneToDelete.id}${force ? '?force=true' : ''}`;
      console.log(`Sending delete request to: ${url}`);
      
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${auth}`,
        },
      });
      
      let data;
      try {
        data = await response.json();
      } catch (err) {
        console.error('Failed to parse response JSON:', err);
        data = { success: false, error: 'Invalid response format' };
      }
      
      if (response.ok) {
        if (data.success) {
          showSnackbar(`Phone number ${phoneToDelete.phone_number} deleted successfully`, 'success');
          handleCloseDeleteDialog();
          fetchPhoneNumbers(); // Refresh the list
        } else {
          showSnackbar(data.error || 'Error deleting phone number', 'error');
        }
      } else {
        // Special handling for 422 Unprocessable Entity errors and other errors with force option
        if (response.status === 422 || data.force_message) {
          setShowForceDelete(true);
          setDeleteError(data.error || 'Failed to release phone number');
          
          // If there are detailed errors, log them
          if (data.errors && Array.isArray(data.errors)) {
            console.error('Detailed delete errors:', data.errors);
          }
        } else {
          showSnackbar(data.error || `Error deleting phone number (Status ${response.status})`, 'error');
        }
      }
    } catch (error) {
      console.error('Error deleting phone number:', error);
      showSnackbar('Error deleting phone number: ' + (error.message || 'Unknown error'), 'error');
    } finally {
      setDeletingPhone(false);
    }
  };

  const handleForceDeletePhoneNumber = async () => {
    await handleDeletePhoneNumber(true);
  };

  // Add handlers for SIP URI dialog
  const handleCloseSipUriDialog = () => {
    setTrunkToEditSip(null);
    setNewSipUri('');
    setNewSipFriendlyName('');
    setSipUriDialog(false);
  };

  const handleSaveSipUri = async () => {
    if (!agentForSipUri || !agentSipUri) {
      showSnackbar('Please select an agent and enter a SIP URI', 'error');
      return;
    }
    
    setSavingSipUri(true);
    try {
      // First, save the SIP URI to the agent
      const response = await fetch(`${API_PATH}/api/agents/${agentForSipUri.id}/sip-uri`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ sipUri: agentSipUri })
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar('SIP URI saved successfully');
          
          // Check if any phone numbers are assigned to this agent in the database
          try {
            // Query to find phone numbers assigned to this agent
            const assignedResponse = await fetch(`${API_PATH}/api/agents/${agentForSipUri.id}/phone-numbers`, {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            });
            
            if (assignedResponse.ok) {
              const assignedData = await assignedResponse.json();
              
              if (assignedData.phoneNumbers && assignedData.phoneNumbers.length > 0) {
                // Use the first assigned phone number
                const assignedPhone = assignedData.phoneNumbers[0];
                showSnackbar('Setting up LiveKit integration...', 'info');
                
                try {
                  // Call the LiveKit integration endpoint
                  const livekitResponse = await fetch(`${API_PATH}/api/didww/livekit-integration`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    body: JSON.stringify({ 
                      phoneNumberId: assignedPhone.id,
                      agentId: agentForSipUri.id
                    })
                  });
                  
                  if (livekitResponse.ok) {
                    const livekitData = await livekitResponse.json();
                    if (livekitData.success) {
                      showSnackbar('LiveKit integration established successfully', 'success');
                    } else {
                      console.error('Error setting up LiveKit integration:', livekitData.error);
                      showSnackbar(livekitData.error || 'Error setting up LiveKit integration', 'warning');
                    }
                  } else {
                    console.error('Error response setting up LiveKit integration:', await livekitResponse.text());
                    showSnackbar('SIP URI was saved, but LiveKit integration setup failed', 'warning');
                  }
                } catch (livekitError) {
                  console.error('Exception setting up LiveKit integration:', livekitError);
                  showSnackbar('SIP URI was saved, but LiveKit integration setup failed', 'warning');
                }
              } else {
                console.log('No phone numbers assigned to this agent, skipping LiveKit integration setup');
              }
            }
          } catch (assignedError) {
            console.error('Error checking for assigned phone numbers:', assignedError);
          }
          
          handleCloseSipUriDialog();
          
          // If we were in the middle of purchasing a phone number, continue with that process
          if (purchaseAfterSipUri && selectedNumber) {
            handlePurchaseSelectedNumber();
          } else if (purchaseAfterSipUri) {
            openPurchaseDialog();
          }
          
          // Refresh the agent list to show the updated URI
          fetchAgents();
        } else {
          showSnackbar(data.error || 'Error saving SIP URI', 'error');
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        showSnackbar(errorData.error || 'Error saving SIP URI', 'error');
      }
    } catch (error) {
      console.error('Error saving SIP URI:', error);
      showSnackbar('Error saving SIP URI', 'error');
    } finally {
      setSavingSipUri(false);
    }
  };

  // Add new handler for opening the assign dialog
  const handleOpenAssignDialog = (phoneNumber) => {
    setPhoneToAssign(phoneNumber);
    setSelectedAgent('');
    setAssignDialog(true);
  };

  // Add new handler for closing the assign dialog
  const handleCloseAssignDialog = () => {
    setAssignDialog(false);
    setPhoneToAssign(null);
  };

  // Add new handler for assigning phone number to agent
  const handleAssignPhoneNumber = async () => {
    if (!phoneToAssign) {
      showSnackbar('No phone number selected', 'error');
      return;
    }
    
    if (!selectedAgent) {
      showSnackbar('Please select an agent', 'error');
      return;
    }
    
    setAssigningPhone(true);
    try {
      const response = await fetch(`${API_PATH}/didww/numbers/${phoneToAssign.id}/assign`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          agentId: selectedAgent 
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar('Phone number assigned successfully');
          handleCloseAssignDialog();
          fetchPhoneNumbers(); // Refresh the list
        } else {
          showSnackbar(data.error || 'Error assigning phone number', 'error');
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        
        // Check if we need to set a SIP URI for the agent
        if (response.status === 400 && errorData.needs_sip_uri) {
          setAssigningPhone(false);
          // Find the agent details
          const agent = agents.find(a => a.id === selectedAgent);
          setAgentForSipUri(agent);
          setSipUriDialog(true);
          // Don't set purchaseAfterSipUri here
          return;
        }
        
        showSnackbar(errorData.error || 'Error assigning phone number', 'error');
      }
    } catch (error) {
      console.error('Error assigning phone number:', error);
      showSnackbar('Error assigning phone number', 'error');
    } finally {
      setAssigningPhone(false);
    }
  };

  const handlePurchaseSelectedNumber = async () => {
    if (!selectedNumber) return;
    
    try {
      const response = await fetch(`${API_PATH}/api/phone/purchase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify({
          phoneNumber: selectedNumber.phoneNumber,
          areaCode: selectedNumber.areaCode
        })
      });

      if (!response.ok) {
        throw new Error('Failed to purchase phone number');
      }

      // Refresh the phone numbers list
      fetchPhoneNumbers();
      setSelectedNumber(null);
      showSnackbar('Phone number purchased successfully', 'success');
    } catch (error) {
      console.error('Error purchasing phone number:', error);
      showSnackbar('Failed to purchase phone number', 'error');
    }
  };

  const handleOpenUpdateDialog = (phone) => {
    setSelectedPhone(phone);
    // Pre-populate with the current agent assignment if any
    if (phone.agents && phone.agents.length > 0) {
      setSelectedAgent(phone.agents[0]);
    } else {
      setSelectedAgent('');
    }
    setUpdateDialogOpen(true);
  };

  const handleCloseUpdateDialog = () => {
    setUpdateDialogOpen(false);
    setSelectedPhone(null);
    setSelectedAgent('');
  };

  const handleUpdatePhoneNumber = async () => {
    if (!selectedPhone) {
      showSnackbar('No phone number selected', 'error');
      return;
    }

    try {
      setLoading(true);
      
      const response = await fetch(`${API_PATH}/didww/numbers/${selectedPhone.id}/update`, {
        method: 'POST',  // Note: DIDWW uses POST instead of PUT for updates
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agentId: selectedAgent || null,
          friendlyName: selectedPhone.friendly_name
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar('Phone number updated successfully');
          handleCloseUpdateDialog();
          fetchPhoneNumbers(); // Refresh the list
        } else {
          showSnackbar(data.error || 'Error updating phone number', 'error');
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        showSnackbar(errorData.error || 'Error updating phone number', 'error');
      }
    } catch (error) {
      console.error('Error updating phone number:', error);
      showSnackbar('Error updating phone number', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Add helper function to determine number type display
  const _getNumberTypeDisplay = (number) => {
    if (!number.capabilities) return 'Unknown';
    
    const capabilities = number.capabilities;
    
    // Most Mobile numbers support SMS
    if (capabilities.sms || capabilities.SMS) {
      return 'Mobile';
    }
    // Local numbers typically only support voice
    else if ((capabilities.voice || capabilities.Voice) && 
            !(capabilities.sms || capabilities.SMS)) {
      return 'Local';
    }
    // Toll free detection
    else if (number.phone_number && (
      number.phone_number.startsWith('+1800') || 
      number.phone_number.startsWith('+1888') || 
      number.phone_number.startsWith('+1877') ||
      number.phone_number.startsWith('+1866') ||
      (number.friendly_name && number.friendly_name.toLowerCase().includes('toll'))
    )) {
      return 'Toll Free';
    }
    // Default case
    else {
      return 'Local';
    }
  };

  // Function to open Dublin trunk dialog
  const handleOpenDublinDialog = (phoneNumber) => {
    setPhoneToDublin(phoneNumber);
    
    // Pre-populate fields
    if (agents && agents.length > 0) {
      setSelectedAgent(selectedAgent || agents[0].id);
    }
    
    // Generate default SIP URI with Dublin edge parameter
    // Use existing agent SIP URI if possible
    const selectedAgentObj = selectedAgent ? agents.find(a => a.id === selectedAgent) : null;
    let defaultSipUri = '';
    
    if (selectedAgentObj && selectedAgentObj.sip_uri) {
      defaultSipUri = selectedAgentObj.sip_uri;
      // Add Dublin edge parameter if not present
      if (!defaultSipUri.includes(';edge=dublin')) {
        defaultSipUri = defaultSipUri.includes(';') 
          ? `${defaultSipUri.split(';')[0]};edge=dublin`
          : `${defaultSipUri};edge=dublin`;
      }
    } else {
      // Generate default SIP URI based on agent
      defaultSipUri = `sip:livekit@example.com;edge=dublin`;
    }
    
    setDublinSipUri(defaultSipUri);
    setDublinFriendlyName(`AIForce Dublin Trunk for ${phoneNumber.phone_number}`);
    setDublinDialog(true);
  };
  
  // Function to close Dublin trunk dialog
  const handleCloseDublinDialog = () => {
    setDublinDialog(false);
    setPhoneToDublin(null);
    setDublinSipUri('');
    setDublinFriendlyName('AIForce Dublin Trunk');
  };
  
  // Function to create Dublin trunk and connect to LiveKit
  const handleCreateDublinTrunk = async () => {
    if (!phoneToDublin || !selectedAgent || !dublinSipUri) {
      showSnackbar('Missing required fields', 'error');
      return;
    }
    
    setCreatingDublinTrunk(true);
    
    if (!dublinSipUri.includes(';edge=dublin')) {
      dublinSipUri += ';edge=dublin';
    }
    
    try {
      const response = await fetch(`${API_PATH}/api/twilio/numbers/dublin-trunk`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify({
          phoneNumberId: phoneToDublin.id,
          agentId: selectedAgent,
          sipUri: dublinSipUri,
          friendlyName: dublinFriendlyName || `AIForce Dublin Trunk for ${phoneToDublin.phone_number}`
        })
      });
      
      let data;
      try {
        data = await response.json();
      } catch (error) {
        console.error('Error parsing response JSON:', error);
        data = {};
      }
      
      if (response.ok) {
        // Check for partial success
        if (data.warning) {
          console.log('Partial success:', data);
          showSnackbar(data.message, 'warning');
        } else {
          console.log('Dublin trunk created:', data);
          showSnackbar('Dublin trunk created successfully!', 'success');
        }
        
        // Close the dialog
        handleCloseDublinDialog();
        
        // Refresh phone numbers to get the updated trunk status
        fetchPhoneNumbers();
        
        // If LiveKit integration was skipped, show notification to user
        if (data.warning && data.warning.includes('LiveKit')) {
          showSnackbar(data.error || 'Error setting up LiveKit integration', 'error');
        }
      } else {
        if (response.status === 400 && data.needs_sip_uri) {
          setCreatingLivekitIntegration(false);
          // Find the agent details
          const agent = agents.find(a => a.id === selectedAgent);
          setAgentForSipUri(agent);
          setSipUriDialog(true);
          setLivekitIntegrationDialog(false); // Close the current dialog
          return;
        }
        
        showSnackbar(data.error || 'Error setting up LiveKit integration', 'error');
      }
    } catch (error) {
      console.error('Error setting up LiveKit integration:', error);
      showSnackbar('Error setting up LiveKit integration', 'error');
    } finally {
      setCreatingDublinTrunk(false);
    }
  };

  // Add function to fetch Dublin trunks
  const fetchDublinTrunks = async () => {
    try {
      setLoadingDublinTrunks(true);
      const response = await fetch(`${API_PATH}/api/twilio/dublin-trunks`, {
        headers: {
          'Authorization': `Bearer ${auth}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          console.log('Dublin trunks:', data.trunks);
          // Fetch details for each trunk to get origination URLs
          const trunksWithDetails = await Promise.all(
            data.trunks.map(async (trunk) => {
              const detailsResponse = await fetch(`${API_PATH}/api/twilio/dublin-trunks/${trunk.sid}`, {
                headers: {
                  'Authorization': `Bearer ${auth}`
                }
              });
              
              if (detailsResponse.ok) {
                const detailsData = await detailsResponse.json();
                if (detailsData.success) {
                  return detailsData.trunk;
                }
              }
              return trunk;
            })
          );
          setDublinTrunks(trunksWithDetails);
        } else {
          console.error('Error fetching Dublin trunks:', data.error);
          showSnackbar(`Error: ${data.error}`, 'error');
        }
      } else {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        showSnackbar(`Error: ${errorData.error}`, 'error');
      }
    } catch (error) {
      console.error('Error fetching Dublin trunks:', error);
      showSnackbar('Error fetching Dublin trunks', 'error');
    } finally {
      setLoadingDublinTrunks(false);
    }
  };
  
  const fetchDublinTrunkDetails = async (trunkSid) => {
    try {
      const response = await fetch(`${API_PATH}/api/twilio/dublin-trunks/${trunkSid}`, {
        headers: {
          'Authorization': `Bearer ${auth}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          return data.trunk;
        } else {
          console.error('Error fetching Dublin trunk details:', data.error);
          showSnackbar(`Error: ${data.error}`, 'error');
        }
      } else {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        showSnackbar(`Error: ${errorData.error}`, 'error');
      }
    } catch (error) {
      console.error('Error fetching Dublin trunk details:', error);
      showSnackbar('Error fetching Dublin trunk details', 'error');
    }
    return null;
  };
  
  const handleDeleteDublinTrunk = async (trunkSid) => {
    try {
      const response = await fetch(`${API_PATH}/api/twilio/dublin-trunks/${trunkSid}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${auth}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          // Remove the trunk from the list
          setDublinTrunks(prevTrunks => prevTrunks.filter(trunk => trunk.sid !== trunkSid));
          // Update phone numbers to remove the trunk SID
          setPhoneNumbers(prevNumbers => 
            prevNumbers.map(phone => 
              phone.twilio_trunk_sid === trunkSid 
                ? { ...phone, twilio_trunk_sid: null, twilio_origination_url_sid: null }
                : phone
            )
          );
          showSnackbar('Dublin trunk deleted successfully', 'success');
        } else {
          showSnackbar(`Error: ${data.error}`, 'error');
        }
      } else {
        const errorData = await response.json();
        showSnackbar(`Error: ${errorData.error}`, 'error');
      }
    } catch (error) {
      console.error('Error deleting Dublin trunk:', error);
      showSnackbar('Error deleting Dublin trunk', 'error');
    }
  };
  
  const handleConnectPhoneToTrunk = async (phoneId, trunkSid) => {
    try {
      const response = await fetch(`${API_PATH}/api/twilio/numbers/${phoneId}/connect-dublin-trunk`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify({
          trunkSid
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          // Update the phone number in the list
          setPhoneNumbers(prevNumbers => 
            prevNumbers.map(phone => 
              phone.id === phoneId 
                ? { ...phone, twilio_trunk_sid: trunkSid }
                : phone
            )
          );
          showSnackbar('Phone number connected to Dublin trunk successfully', 'success');
          // Refresh Dublin trunks
          fetchDublinTrunks();
        } else {
          showSnackbar(`Error: ${data.error}`, 'error');
        }
      } else {
        const errorData = await response.json();
        showSnackbar(`Error: ${errorData.error}`, 'error');
      }
    } catch (error) {
      console.error('Error connecting phone to Dublin trunk:', error);
      showSnackbar('Error connecting phone to Dublin trunk', 'error');
    }
  };
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  // Function to get phone number by trunk SID
  const getPhoneForTrunk = (trunkSid) => {
    return phoneNumbers.find(phone => phone.twilio_trunk_sid === trunkSid);
  };
  
  // Function to get agent by ID
  const getAgentById = (agentId) => {
    return agents.find(agent => agent.id === agentId);
  };

  const handleOpenTrunkDetailsDialog = (trunk) => {
    setSelectedTrunk(trunk);
    setTrunkDetailsDialog(true);
  };

  const handleCloseTrunkDetailsDialog = () => {
    setSelectedTrunk(null);
    setTrunkDetailsDialog(false);
  };
  
  const handleOpenConnectPhoneDialog = (trunk) => {
    setTrunkToConnect(trunk);
    setPhoneToConnectDialog(true);
  };
  
  const handleCloseConnectPhoneDialog = () => {
    setTrunkToConnect(null);
    setSelectedPhoneToConnect(null);
    setPhoneToConnectDialog(false);
  };
  
  const handleConnectPhoneToTrunkSubmit = async () => {
    if (!selectedPhoneToConnect || !trunkToConnect) {
      showSnackbar('Please select a phone number', 'error');
      return;
    }
    
    setConnectingPhone(true);
    try {
      await handleConnectPhoneToTrunk(selectedPhoneToConnect.id, trunkToConnect.sid);
      handleCloseConnectPhoneDialog();
    } catch (error) {
      console.error('Error connecting phone to trunk:', error);
    } finally {
      setConnectingPhone(false);
    }
  };

  const handleOpenSipUriDialog = (trunk) => {
    setTrunkToEditSip(trunk);
    // Get existing SIP URI if available
    if (trunk.origination_urls && trunk.origination_urls.length > 0) {
      setNewSipUri(trunk.origination_urls[0].sip_url);
      setNewSipFriendlyName(trunk.origination_urls[0].friendly_name || '');
    } else {
      setNewSipUri('');
      setNewSipFriendlyName('');
    }
    setSipUriDialog(true);
  };
  
  const handleUpdateSipUri = async () => {
    if (!trunkToEditSip || !newSipUri) {
      showSnackbar('Please enter a valid SIP URI', 'error');
      return;
    }
    
    setUpdatingSipUri(true);
    try {
      const response = await fetch(`${API_PATH}/api/twilio/dublin-trunks/${trunkToEditSip.sid}/sip-uri`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify({
          sip_uri: newSipUri,
          friendly_name: newSipFriendlyName || `SIP URI for ${trunkToEditSip.sid}`
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar('SIP URI updated successfully', 'success');
          // Update the trunk in the local state
          setDublinTrunks(prevTrunks => 
            prevTrunks.map(trunk => 
              trunk.sid === trunkToEditSip.sid 
                ? { 
                    ...trunk, 
                    origination_urls: [
                      {
                        sip_url: newSipUri,
                        friendly_name: newSipFriendlyName,
                        sid: data.origination_url_sid
                      }
                    ]
                  }
                : trunk
            )
          );
          handleCloseSipUriDialog();
        } else {
          showSnackbar(`Error: ${data.error}`, 'error');
        }
      } else {
        const errorData = await response.json();
        showSnackbar(`Error: ${errorData.error}`, 'error');
      }
    } catch (error) {
      console.error('Error updating SIP URI:', error);
      showSnackbar('Error updating SIP URI', 'error');
    } finally {
      setUpdatingSipUri(false);
    }
  };

  const handleSubmitSipUri = async () => {
    if (!agentForSipUri || !sipUri) {
      showSnackbar('Missing agent or SIP URI', 'error');
      return;
    }
    
    setSubmittingSipUri(true);
    try {
      const response = await fetch(`${API_PATH}/api/agents/${agentForSipUri.id}/sip_uri`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ 
          sipUri: sipUri
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          showSnackbar('SIP URI updated successfully', 'success');
          setSipUriDialog(false);
          fetchAgents(); // Refresh agent data
          
          // If we were in the middle of LiveKit integration, reopen that dialog
          if (phoneForLivekit) {
            setLivekitIntegrationDialog(true);
          }
        } else {
          showSnackbar(data.error || 'Failed to update SIP URI', 'error');
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        showSnackbar(errorData.error || 'Failed to update SIP URI', 'error');
      }
    } catch (error) {
      console.error('Error updating SIP URI:', error);
      showSnackbar('Error updating SIP URI', 'error');
    } finally {
      setSubmittingSipUri(false);
    }
  };

  // Function to open LiveKit integration dialog
  const handleOpenLivekitDialog = (phone) => {
    setPhoneForLivekit(phone);
    setLivekitIntegrationDialog(true);
  };

  // Function to close LiveKit integration dialog
  const handleCloseLivekitDialog = () => {
    setLivekitIntegrationDialog(false);
    setPhoneForLivekit(null);
    setCreatingLivekit(false);
  };

  // Function to create LiveKit integration
  const handleCreateLivekitIntegration = async () => {
    if (!phoneForLivekit) {
      showSnackbar('No phone number selected', 'error');
      return;
    }

    setCreatingLivekit(true);
    
    try {
      const response = await fetch(`${API_PATH}/api/livekit/integration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`
        },
        body: JSON.stringify({
          phoneNumberId: phoneForLivekit.id,
          agentId: phoneForLivekit.agents[0], // Use the first assigned agent
          trunkSid: phoneForLivekit.twilio_trunk_sid
        })
      });
      
      let data;
      try {
        data = await response.json();
      } catch (error) {
        console.error('Error parsing response JSON:', error);
        data = {};
      }
      
      if (response.ok) {
        if (data.success) {
          showSnackbar('LiveKit integration created successfully!', 'success');
          handleCloseLivekitDialog();
          fetchPhoneNumbers(); // Refresh phone numbers to get updated LiveKit status
        } else {
          showSnackbar(data.error || 'Error creating LiveKit integration', 'error');
        }
      } else {
        if (response.status === 400 && data.needs_sip_uri) {
          // If agent needs SIP URI, prompt the user to set it
          const agent = agents.find(a => a.id === phoneForLivekit.agents[0]);
          setAgentForSipUri(agent);
          setSipUriDialog(true);
          setLivekitIntegrationDialog(false); // Close the current dialog
          return;
        }
        
        showSnackbar(data.error || 'Error creating LiveKit integration', 'error');
      }
    } catch (error) {
      console.error('Error creating LiveKit integration:', error);
      showSnackbar('Error creating LiveKit integration', 'error');
    } finally {
      setCreatingLivekit(false);
    }
  };

  // Add function to open transfer dialog and load users
  const handleOpenTransferDialog = (phone) => {
    setSelectedPhoneNumber(phone);
    setTransferToUser('');
    setTransferDialogOpen(true);
    fetchUsers(); // Load users when opening the dialog
  };

  const handleCloseTransferDialog = () => {
    setTransferDialogOpen(false);
    setSelectedPhoneNumber(null);
    setTransferToUser('');
  };

  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const response = await fetch(`${API_PATH}/api/users`, {
        headers: {
          'Authorization': `Bearer ${auth}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUsers(data.filter(u => u.id !== user.id)); // Exclude current user
      } else {
        console.error('Failed to fetch users');
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleTransferPhoneNumber = async () => {
    if (!selectedPhoneNumber || !transferToUser) {
      showSnackbar('Please select a phone number and a user to transfer to', 'error');
      return;
    }

    try {
      setTransferringPhone(true);
      const response = await fetch(`${API_PATH}/api/phone-numbers/${selectedPhoneNumber.id}/transfer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ user_id: transferToUser })
      });

      if (response.ok) {
        showSnackbar('Phone number transferred successfully', 'success');
        fetchPhoneNumbers();
        handleCloseTransferDialog();
      } else {
        const error = await response.json();
        throw new Error(error.message || 'Failed to transfer phone number');
      }
    } catch (error) {
      console.error('Error transferring phone number:', error);
      showSnackbar(error.message || 'Failed to transfer phone number', 'error');
    } finally {
      setTransferringPhone(false);
    }
  };

  const handleTransferUserChange = (event) => {
    setTransferToUser(event.target.value);
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={0} aria-label="phone management tabs">
          <Tab label="Phone Numbers" id="tab-0" />
        </Tabs>
      </Box>
      
      {/* Phone Numbers Tab */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Phone Numbers
        </Typography>
        {isAdmin && (
          <Button 
            variant="contained" 
            color="primary"
            startIcon={<AddIcon />}
            onClick={openPurchaseDialog}
            disabled={loading}
          >
            Purchase Number
          </Button>
        )}
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : phoneNumbers.length === 0 ? (
        <Typography variant="body1" sx={{ textAlign: 'center', py: 5 }}>
          No phone numbers found. {isAdmin ? 'Purchase a new phone number to get started.' : 'Contact your administrator to set up phone numbers.'}
        </Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Phone Number</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Region</TableCell>
                <TableCell>SIP Trunk</TableCell>
                <TableCell>Agent</TableCell>
                {isAdmin && <TableCell>Owner</TableCell>}
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {phoneNumbers.map((phone) => (
                <TableRow key={phone.id}>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <PhoneIcon sx={{ mr: 1, fontSize: 20, color: 'primary.main' }} />
                      {phone.phone_number || phone.phoneNumber}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={phone.type || _getNumberTypeDisplay(phone)} 
                      size="small"
                      color={phone.type === 'mobile' ? 'secondary' : 'primary'}
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{phone.country}</TableCell>
                  <TableCell>{phone.region || 'N/A'}</TableCell>
                  <TableCell>
                    {phone.twilio_trunk_sid ? (
                      <Chip
                        label={phone.twilio_trunk_sid}
                        size="small"
                        color="primary"
                        variant="outlined"
                      />
                    ) : (
                      <Chip
                        label="No trunk"
                        size="small"
                        variant="outlined"
                        color="default"
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {phone.agents && phone.agents.length > 0 ? (
                      phone.agents.map(agentId => {
                        const agent = agents.find(a => a.id === agentId);
                        return (
                          <Chip
                            key={agentId}
                            label={agent ? agent.name : 'Unknown Agent'}
                            size="small"
                            color="success"
                            variant="outlined"
                            sx={{ mr: 0.5, mb: 0.5 }}
                          />
                        );
                      })
                    ) : (
                      <Chip
                        label="Not assigned"
                        size="small"
                        variant="outlined"
                        color="default"
                      />
                    )}
                  </TableCell>
                  {isAdmin && (
                    <TableCell>
                      {phone.owner_email ? (
                        <Tooltip title="Transfer ownership">
                          <Chip
                            label={phone.owner_email}
                            size="small"
                            color="info"
                            variant="outlined"
                            onClick={() => handleOpenTransferDialog(phone)}
                            sx={{ cursor: 'pointer' }}
                          />
                        </Tooltip>
                      ) : (
                        <Chip
                          label="Unknown"
                          size="small"
                          variant="outlined"
                          color="default"
                        />
                      )}
                    </TableCell>
                  )}
                  <TableCell align="right">
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => handleOpenUpdateDialog(phone)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {isAdmin && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => handleOpenDeleteDialog(phone)}
                        sx={{ ml: 1 }}
                      >
                        Delete
                      </Button>
                    )}
                    {phone.agents && phone.agents.length === 0 && (
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        startIcon={<LinkIcon />}
                        onClick={() => handleOpenAssignDialog(phone)}
                        sx={{ ml: 1 }}
                      >
                        Assign
                      </Button>
                    )}
                    {phone.twilio_trunk_sid && !phone.livekit_trunk_id && (
                      <Tooltip title="Create LiveKit Integration">
                        <Button
                          color="secondary"
                          variant="outlined"
                          onClick={() => handleOpenLivekitDialog(phone)}
                          size="small"
                          sx={{ ml: 1 }}
                        >
                          LiveKit Integration
                        </Button>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      
      {/* Purchase Phone Number Dialog */}
      <Dialog
        open={purchaseDialog}
        onClose={handleClosePurchaseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Purchase Phone Number</DialogTitle>
        <DialogContent>
          <Box sx={{ my: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Country
            </Typography>

            <Box sx={{ p: 2 }}>
              <Box component="form" sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                <Button
                  variant={selectedCountry ? 'outlined' : 'contained'}
                  onClick={handleCountryMenuOpen}
                  endIcon={<ArrowDropDownIcon />}
                  sx={{ mr: 1, minWidth: '200px', textAlign: 'left', justifyContent: 'flex-start' }}
                >
                  {loadingCountries ? (
                    <CircularProgress size={24} />
                  ) : (
                    selectedCountry ? getCountryName(selectedCountry) : 'Select Country'
                  )}
                </Button>
                <Popover
                  open={Boolean(countryMenu)}
                  anchorEl={countryMenu}
                  onClose={handleCountryMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  {loadingCountries ? (
                    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                      <CircularProgress size={24} />
                    </Box>
                  ) : (
                    <List sx={{ maxHeight: '300px', overflow: 'auto', minWidth: '200px' }}>
                      {countries.map((country) => (
                        <ListItem 
                          button 
                          key={country.code} 
                          onClick={() => handleSelectCountry(country.code)}
                        >
                          <ListItemText primary={country.name} />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Popover>

                <FormControl sx={{ minWidth: 150, ml: 2 }}>
                  <InputLabel id="number-type-label">Number Type</InputLabel>
                  <Select
                    labelId="number-type-label"
                    id="number-type-select"
                    value={selectedNumberType}
                    label="Number Type"
                    onChange={handleSelectNumberType}
                  >
                    <MenuItem value="local">Local</MenuItem>
                    <MenuItem value="mobile">Mobile</MenuItem>
                    <MenuItem value="toll_free">Toll Free</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="agent-select-label">Assign to Agent (Optional)</InputLabel>
              <Select
                labelId="agent-select-label"
                id="agent-select"
                value={selectedAgent}
                label="Assign to Agent (Optional)"
                onChange={handleAgentChange}
              >
                <MenuItem value="">
                  <em>None (unassigned)</em>
                </MenuItem>
                {agents.map((agent) => (
                  <MenuItem key={agent.id} value={agent.id}>
                    {agent.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                You can optionally assign this number to an agent now, or do it later from the phone numbers list
              </FormHelperText>
            </FormControl>
          </Box>

          {loadingNumbers ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress />
            </Box>
          ) : availableNumbers.length > 0 ? (
            <>
              <Typography variant="h6" gutterBottom>
                Available Numbers
              </Typography>
              <List>
                {availableNumbers.map((number, index) => (
                  <React.Fragment key={number.phone_number || number.phoneNumber}>
                    <ListItem
                      button
                      selected={selectedNumber?.phone_number === number.phone_number || selectedNumber?.phoneNumber === number.phoneNumber}
                      onClick={() => handleSelectNumber(number)}
                      sx={{
                        '&.Mui-selected': {
                          backgroundColor: 'primary.light',
                          '&:hover': {
                            backgroundColor: 'primary.light',
                          },
                        },
                        borderLeft: (selectedNumber?.phone_number === number.phone_number || selectedNumber?.phoneNumber === number.phoneNumber) ? 
                          '4px solid' : 'none',
                        borderColor: 'primary.main',
                        pl: (selectedNumber?.phone_number === number.phone_number || selectedNumber?.phoneNumber === number.phoneNumber) ? 
                          1.5 : 2
                      }}
                    >
                      <ListItemText
                        primary={number.phone_number || number.phoneNumber}
                        secondary={
                          <>
                            <Typography component="span" variant="body2" color="textPrimary">
                              {number.type || _getNumberTypeDisplay(number)} 
                              {number.region ? ` (${number.region})` : ''}
                            </Typography>
                            <br />
                            <Typography component="span" variant="body2" color="textSecondary">
                              Capabilities: {Object.entries(number.capabilities || {})
                                .filter(([_, value]) => value)
                                .map(([key]) => key.toUpperCase())
                                .join(', ')}
                            </Typography>
                          </>
                        }
                      />
                    </ListItem>
                    {index < availableNumbers.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            </>
          ) : selectedCountry ? (
            <Typography>No phone numbers available for this country</Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePurchaseDialog}>Cancel</Button>
          <Button 
            onClick={handlePurchaseNumber} 
            disabled={!selectedNumber || purchasingNumber}
            variant="contained"
            color="primary"
          >
            {purchasingNumber ? 'Purchasing...' : 'Purchase Number'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Purchase Progress Dialog */}
      <Dialog
        open={purchaseProgressOpen}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { p: 2 }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', pb: 1 }}>
          {purchaseResult.success === null ? 'Purchasing Phone Number' : (
            purchaseResult.success ? 
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CheckCircleIcon color="success" sx={{ mr: 1 }} />
              Purchase Complete
            </Box> : 
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ErrorIcon color="error" sx={{ mr: 1 }} />
              Purchase Failed
            </Box>
          )}
        </DialogTitle>
        <DialogContent>
          {/* Show progress steps when in progress */}
          {purchaseResult.success === null && (
            <Box sx={{ width: '100%', mt: 2 }}>
              <Stepper orientation="vertical" activeStep={-1}>
                {purchaseSteps.map((step, index) => (
                  <Step key={step.label} active={step.current} completed={step.completed}>
                    <StepLabel
                      StepIconProps={{
                        icon: step.completed ? <CheckCircleIcon color="success" /> : 
                               step.current ? <CircularProgress size={24} /> : index + 1
                      }}
                    >
                      {step.label}
                    </StepLabel>
                    <StepContent>
                      <Typography variant="body2" color="text.secondary">
                        {index === 0 && 'Starting your purchase request...'}
                        {index === 1 && 'Retrieving details for the selected phone number...'}
                        {index === 2 && 'Sending order to DIDWW API...'}
                        {index === 3 && 'Waiting for order confirmation from DIDWW...'}
                        {index === 4 && 'Finalizing your purchase and adding number to your account...'}
                      </Typography>
                    </StepContent>
                  </Step>
                ))}
              </Stepper>
            </Box>
          )}
          
          {/* Show result when complete */}
          {purchaseResult.success !== null && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              {purchaseResult.success ? (
                <Box>
                  <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
                    <CheckCircleIcon color="success" sx={{ fontSize: 60 }} />
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {purchaseResult.message}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {purchaseResult.details}
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
                    <ErrorIcon color="error" sx={{ fontSize: 60 }} />
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {purchaseResult.message}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {purchaseResult.details}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {purchaseResult.success !== null && (
            <Button 
              onClick={() => {
                setPurchaseProgressOpen(false);
                if (purchaseResult.success) {
                  // If successful, we've already closed the purchase dialog
                } else {
                  // If failed, go back to the purchase dialog
                  setSelectedNumber(null);
                }
              }}
            >
              {purchaseResult.success ? 'Close' : 'Try Again'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Origination URI Dialog */}
      <Dialog
        open={originationDialog}
        onClose={handleCloseOriginationDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Set Origination URI</DialogTitle>
        <DialogContent>
          {selectedPhone && (
            <Box sx={{ my: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Phone Number: {selectedPhone.phone_number}
              </Typography>
              
              <TextField
                margin="dense"
                label="SIP URI"
                fullWidth
                value={sipUriValue}
                onChange={(e) => setSipUriValue(e.target.value)}
                helperText="Example: sip:example.com;transport=tcp"
                sx={{ mb: 2 }}
              />
              
              <TextField
                margin="dense"
                label="Friendly Name"
                fullWidth
                value={friendlyName}
                onChange={(e) => setFriendlyName(e.target.value)}
                sx={{ mb: 2 }}
              />
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    margin="dense"
                    label="Priority"
                    type="number"
                    fullWidth
                    value={priorityValue}
                    onChange={(e) => setPriorityValue(e.target.value)}
                    helperText="Lower values have higher priority (1-65535)"
                    InputProps={{ inputProps: { min: 1, max: 65535 } }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    margin="dense"
                    label="Weight"
                    type="number"
                    fullWidth
                    value={weightValue}
                    onChange={(e) => setWeightValue(e.target.value)}
                    helperText="Higher values get more traffic (1-65535)"
                    InputProps={{ inputProps: { min: 1, max: 65535 } }}
                  />
                </Grid>
              </Grid>
              
              {originationUrls.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Current Origination URLs
                  </Typography>
                  <List dense>
                    {originationUrls.map((url) => (
                      <ListItem key={url.sid}>
                        <ListItemText
                          primary={url.sip_url}
                          secondary={`Priority: ${url.priority}, Weight: ${url.weight}`}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
              
              {!trunkSid && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  No SIP trunk available. A SIP trunk is required to set origination URIs.
                </Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseOriginationDialog}>Cancel</Button>
          <Button 
            onClick={handleUpdateOrigination} 
            disabled={!sipUriValue || loadingOriginationUpdate}
            variant="contained"
            color="primary"
          >
            {loadingOriginationUpdate ? 'Updating...' : originationUrls.length > 0 ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Phone Number Dialog */}
      <Dialog
        open={deleteDialog}
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Delete Phone Number</DialogTitle>
        <DialogContent>
          {phoneToDelete && (
            <Box sx={{ py: 1 }}>
              {!showForceDelete ? (
                <>
                  <Typography variant="body1" gutterBottom>
                    Are you sure you want to delete phone number <strong>{phoneToDelete.phone_number}</strong>?
                </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    This will:
                  </Typography>
                  <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                    <Typography component="li" variant="body2">
                      Release the number from your Twilio account
                    </Typography>
                    <Typography component="li" variant="body2">
                      Delete all associated SIP trunks and origination URLs
                    </Typography>
                    <Typography component="li" variant="body2">
                      Remove any LiveKit SIP integrations
                    </Typography>
                    <Typography component="li" variant="body2">
                      Delete the phone number from the database
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="warning.main" sx={{ mt: 2 }}>
                    This action cannot be undone!
                  </Typography>
                </>
              ) : (
                <Box>
                  <Typography color="error" variant="subtitle2" gutterBottom>
                    Error: {deleteError}
                  </Typography>
                  <Alert severity="warning" sx={{ my: 2 }}>
                    Would you like to delete this phone number from the database only?
                    The phone number will remain in your Twilio account.
                  </Alert>
                  <Typography variant="body2" color="text.secondary">
                    This option is useful when:
                    <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                      <Typography component="li" variant="body2">
                        The phone number no longer exists in Twilio
                      </Typography>
                      <Typography component="li" variant="body2">
                        You want to manage the number directly in Twilio
                      </Typography>
                      <Typography component="li" variant="body2">
                        The phone number is being used by other services
                      </Typography>
                    </Box>
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog}>Cancel</Button>
          {!showForceDelete ? (
            <Button 
              onClick={() => handleDeletePhoneNumber(false)} 
              disabled={deletingPhone}
              color="error"
              variant="contained"
              startIcon={deletingPhone ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
            >
              {deletingPhone ? 'Deleting...' : 'Delete'}
            </Button>
          ) : (
            <Button 
              onClick={handleForceDeletePhoneNumber} 
              disabled={deletingPhone}
              color="error"
              variant="contained"
              startIcon={deletingPhone ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
            >
              {deletingPhone ? 'Force Deleting...' : 'Force Delete From Database'}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Add SIP URI Dialog */}
      <Dialog
        open={sipUriDialog}
        onClose={handleCloseSipUriDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Set SIP URI for Agent</DialogTitle>
        <DialogContent>
          {agentForSipUri && (
            <Box sx={{ my: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Agent: {agentForSipUri.name}
              </Typography>
              
              <Typography variant="body2" color="textSecondary" paragraph>
                A SIP URI is required before assigning a phone number to this agent. The SIP URI should be provided by your LiveKit instance.
              </Typography>
              
              <Box sx={{ mb: 3, p: 2, bgcolor: 'background.paper', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>Where to find your SIP URI:</strong>
                </Typography>
                <Typography variant="body2" component="ol" sx={{ pl: 2 }}>
                  <li>Log into your LiveKit Cloud dashboard</li>
                  <li>Go to your project settings</li>
                  <li>Look for the SIP URI under Project {`>`} SIP URI</li>
                  <li>Copy the entire URI including transport parameters</li>
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Format example: <code>sip:myproject.livekit.cloud:5060;transport=tcp</code>
                </Typography>
              </Box>
              
              <TextField
                margin="dense"
                label="SIP URI"
                fullWidth
                value={agentSipUri}
                onChange={(e) => setAgentSipUri(e.target.value)}
                helperText="Please enter the complete SIP URI from your LiveKit project"
                sx={{ mt: 2 }}
                required
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSipUriDialog}>Cancel</Button>
          <Button 
            onClick={handleSaveSipUri} 
            disabled={!agentSipUri.trim() || savingSipUri}
            variant="contained"
            color="primary"
          >
            {savingSipUri ? 'Saving...' : purchaseAfterSipUri ? 'Save and Continue' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Assign Phone Number Dialog */}
      <Dialog
        open={assignDialog}
        onClose={handleCloseAssignDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Assign Phone Number</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select an agent to assign this phone number to.
          </DialogContentText>
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="assign-agent-label">Agent</InputLabel>
              <Select
                labelId="assign-agent-label"
                value={selectedAgent}
                onChange={handleAgentChange}
                label="Agent"
                disabled={assigningPhone}
              >
                {agents.map((agent) => (
                  <MenuItem key={agent.id} value={agent.id}>
                    {agent.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAssignDialog} disabled={assigningPhone}>
            Cancel
          </Button>
          <Button
            onClick={() => handleOpenDublinDialog(phoneToAssign)}
            color="secondary"
            disabled={assigningPhone || !selectedAgent}
          >
            Dublin Trunk
          </Button>
          <Button 
            onClick={handleAssignPhoneNumber} 
            variant="contained" 
            color="primary"
            disabled={assigningPhone || !selectedAgent}
            startIcon={assigningPhone ? <CircularProgress size={20} /> : null}
          >
            {assigningPhone ? 'Assigning...' : 'Standard Assign'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Phone Number Dialog */}
      <Dialog
        open={updateDialogOpen}
        onClose={handleCloseUpdateDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Update Phone Number</DialogTitle>
        <DialogContent>
          {selectedPhone && (
            <Box sx={{ my: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Phone Number: {selectedPhone.phone_number}
              </Typography>
              
              <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
                <Typography variant="body2" gutterBottom>
                  <strong>Current Details:</strong>
                </Typography>
                <Typography variant="body2">
                  Type: {selectedPhone.type || 'Unknown'}
                </Typography>
                <Typography variant="body2">
                  Country: {selectedPhone.country}
                </Typography>
                {selectedPhone.region && (
                  <Typography variant="body2">
                    Region: {selectedPhone.region}
                  </Typography>
                )}
                {selectedPhone.twilio_trunk_sid && (
                  <Typography variant="body2">
                    Trunk SID: {selectedPhone.twilio_trunk_sid}
                  </Typography>
                )}
                {selectedPhone.livekit_trunk_id && (
                  <Typography variant="body2">
                    LiveKit Trunk ID: {selectedPhone.livekit_trunk_id}
                  </Typography>
                )}
              </Box>
              
              <FormControl fullWidth sx={{ mt: 3 }}>
                <InputLabel id="update-agent-label">Assigned Agent</InputLabel>
                <Select
                  labelId="update-agent-label"
                  value={selectedAgent}
                  onChange={handleAgentChange}
                  label="Assigned Agent"
                >
                  <MenuItem value="">
                    <em>None (unassigned)</em>
                  </MenuItem>
                  {agents.map((agent) => (
                    <MenuItem key={agent.id} value={agent.id}>
                      {agent.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  Change the agent assigned to this phone number
                </FormHelperText>
              </FormControl>
              
              {selectedPhone.twilio_trunk_sid && (
                <Alert severity="info" sx={{ mt: 2 }}>
                  This phone number has a Dublin trunk configured. Changing the agent assignment may require reconfiguring the trunk.
                </Alert>
              )}
              
              {!selectedPhone.twilio_trunk_sid && selectedAgent && (
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button 
                    color="secondary"
                    onClick={() => {
                      handleCloseUpdateDialog();
                      handleOpenDublinDialog(selectedPhone);
                    }}
                  >
                    Configure Dublin Trunk Instead
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateDialog}>
            Cancel
          </Button>
          <Button 
            onClick={handleUpdatePhoneNumber} 
            variant="contained"
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dublin Trunk Dialog */}
      <Dialog 
        open={dublinDialog}
        onClose={handleCloseDublinDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Create Dublin Trunk</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            This will create a Dublin SIP trunk and connect it to your phone number for European routing.
          </Typography>
          
          <Box sx={{ mt: 3 }}>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="dublin-agent-select-label">Select Agent</InputLabel>
              <Select
                labelId="dublin-agent-select-label"
                id="dublin-agent-select"
                value={selectedAgent}
                label="Select Agent"
                onChange={(e) => setSelectedAgent(e.target.value)}
                required
              >
                {agents.map((agent) => (
                  <MenuItem key={agent.id} value={agent.id}>
                    {agent.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Select the agent to associate with this Dublin trunk</FormHelperText>
            </FormControl>
            
            <TextField
              fullWidth
              label="SIP URI"
              value={dublinSipUri}
              onChange={(e) => setDublinSipUri(e.target.value)}
              margin="normal"
              required
              helperText="SIP URI should include the Dublin edge parameter (;edge=dublin)"
              error={dublinSipUri && !dublinSipUri.includes(';edge=dublin')}
            />
            
            <TextField
              fullWidth
              label="Friendly Name"
              value={dublinFriendlyName}
              onChange={(e) => setDublinFriendlyName(e.target.value)}
              margin="normal"
              helperText="A descriptive name for this trunk"
            />
            
            {phoneToDublin && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Phone Number Details:
                </Typography>
                <Typography variant="body2">
                  Number: {phoneToDublin.phone_number}
                </Typography>
                <Typography variant="body2">
                  Country: {phoneToDublin.country}
                </Typography>
                {phoneToDublin.twilio_trunk_sid && (
                  <Typography variant="body2" color="warning.main">
                    Warning: This phone number already has a trunk SID assigned: {phoneToDublin.twilio_trunk_sid}
                  </Typography>
                )}
              </Box>
            )}
            
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              This will create a Dublin SIP trunk with the provided SIP URI, connect it to the phone number, and configure LiveKit integration for the selected agent.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDublinDialog}>Cancel</Button>
          <Button 
            onClick={handleCreateDublinTrunk}
            variant="contained"
            color="primary"
            disabled={creatingDublinTrunk || !selectedAgent || !dublinSipUri}
          >
            {creatingDublinTrunk ? (
              <>
                <CircularProgress size={24} sx={{ mr: 1 }} />
                Creating...
              </>
            ) : 'Create Dublin Trunk'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* LiveKit Integration Dialog */}
      <Dialog 
        open={livekitIntegrationDialog}
        onClose={handleCloseLivekitDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Complete LiveKit Integration</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            This will finalize the setup by creating a LiveKit SIP trunk and dispatch rule.
          </Typography>
          
          <Box sx={{ mt: 3 }}>
            {phoneForLivekit && (
              <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Phone Number Details:
                </Typography>
                <Typography variant="body2">
                  Number: {phoneForLivekit.phone_number}
                </Typography>
                <Typography variant="body2">
                  Country: {phoneForLivekit.country}
                </Typography>
                {phoneForLivekit.twilio_trunk_sid && (
                  <Typography variant="body2" color="success.main">
                    Dublin Trunk SID: {phoneForLivekit.twilio_trunk_sid}
                  </Typography>
                )}
                {phoneForLivekit.agents && phoneForLivekit.agents.length > 0 && (
                  <Typography variant="body2">
                    Agent: {agents.find(a => a.id === phoneForLivekit.agents[0])?.name || 'Unknown'}
                  </Typography>
                )}
              </Box>
            )}
            
            <Box sx={{ mt: 3, p: 2, bgcolor: 'info.light', color: 'info.contrastText', borderRadius: 1 }}>
              <Typography variant="subtitle1" gutterBottom>
                LiveKit Integration Process
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li><strong>LiveKit SIP Trunk</strong>: Creates a LiveKit SIP inbound trunk for this phone number</li>
                  <li><strong>LiveKit Dispatch Rule</strong>: Sets up a dispatch rule to direct calls to the proper LiveKit room</li>
                  <li><strong>Complete Connection</strong>: Finishes the setup to enable calls from your Twilio number to your LiveKit instance</li>
                </ol>
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLivekitDialog}>Cancel</Button>
          <Button 
            onClick={handleCreateLivekitIntegration}
            variant="contained"
            color="primary"
            disabled={creatingLivekit || !phoneForLivekit}
          >
            {creatingLivekit ? (
              <>
                <CircularProgress size={24} sx={{ mr: 1 }} />
                Creating...
              </>
            ) : 'Create LiveKit Integration'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
      >
        <Alert severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Trunk Details Dialog */}
      <Dialog
        open={trunkDetailsDialog}
        onClose={handleCloseTrunkDetailsDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Dublin SIP Trunk Details
          <IconButton
            aria-label="close"
            onClick={handleCloseTrunkDetailsDialog}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedTrunk && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Trunk Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Friendly Name</Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>{selectedTrunk.friendly_name || 'None'}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">SID</Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>{selectedTrunk.sid}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Date Created</Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {new Date(selectedTrunk.date_created).toLocaleString()}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2">Recording</Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {selectedTrunk.recording ? selectedTrunk.recording.mode : 'Disabled'}
                  </Typography>
                </Grid>
              </Grid>
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="h6" gutterBottom>
                Origination URLs
              </Typography>
              {selectedTrunk.origination_urls && selectedTrunk.origination_urls.length > 0 ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>SIP URL</TableCell>
                        <TableCell>Priority</TableCell>
                        <TableCell>Weight</TableCell>
                        <TableCell>Enabled</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedTrunk.origination_urls.map((url, index) => (
                        <TableRow key={index}>
                          <TableCell>{url.sip_url}</TableCell>
                          <TableCell>{url.priority}</TableCell>
                          <TableCell>{url.weight}</TableCell>
                          <TableCell>{url.enabled ? 'Yes' : 'No'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No origination URLs configured
                </Typography>
              )}
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="h6" gutterBottom>
                Connected Phone Numbers
              </Typography>
              {selectedTrunk.phone_numbers && selectedTrunk.phone_numbers.length > 0 ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Phone Number</TableCell>
                        <TableCell>SID</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedTrunk.phone_numbers.map((phone, index) => (
                        <TableRow key={index}>
                          <TableCell>{phone.phone_number}</TableCell>
                          <TableCell>{phone.sid}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No phone numbers connected to this trunk
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTrunkDetailsDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Connect Phone to Trunk Dialog */}
      <Dialog
        open={phoneToConnectDialog}
        onClose={handleCloseConnectPhoneDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Connect Phone Number to Dublin Trunk
          <IconButton
            aria-label="close"
            onClick={handleCloseConnectPhoneDialog}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {trunkToConnect && (
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                Select a phone number to connect to trunk: {trunkToConnect.friendly_name || trunkToConnect.sid}
              </Typography>
              
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id="phone-select-label">Phone Number</InputLabel>
                <Select
                  labelId="phone-select-label"
                  value={selectedPhoneToConnect ? selectedPhoneToConnect.id : ''}
                  onChange={(e) => {
                    const phoneId = e.target.value;
                    const phone = phoneNumbers.find(p => p.id === phoneId);
                    setSelectedPhoneToConnect(phone);
                  }}
                  label="Phone Number"
                  disabled={connectingPhone}
                >
                  <MenuItem value="">
                    <em>Select a phone number</em>
                  </MenuItem>
                  {phoneNumbers
                    .filter(phone => !phone.twilio_trunk_sid)
                    .map((phone) => (
                      <MenuItem key={phone.id} value={phone.id}>
                        {phone.phone_number} ({phone.friendly_name || 'No name'})
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              
              {phoneNumbers.filter(phone => !phone.twilio_trunk_sid).length === 0 && (
                <Alert severity="info" sx={{ mt: 2 }}>
                  All phone numbers are already connected to trunks. Purchase a new number first.
                </Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleCloseConnectPhoneDialog}
            disabled={connectingPhone}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConnectPhoneToTrunkSubmit}
            variant="contained" 
            color="primary"
            disabled={!selectedPhoneToConnect || connectingPhone}
          >
            {connectingPhone ? <CircularProgress size={24} /> : 'Connect'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Phone Number Transfer Dialog */}
      <Dialog
        open={transferDialogOpen}
        onClose={handleCloseTransferDialog}
        aria-labelledby="transfer-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="transfer-dialog-title">Transfer Phone Number Ownership</DialogTitle>
        <DialogContent>
          {selectedPhoneNumber && (
            <>
              <Typography variant="body1" gutterBottom>
                Phone Number: {selectedPhoneNumber.phone_number}
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Current Owner: {selectedPhoneNumber.owner_email || "Not assigned"}
              </Typography>
              
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id="transfer-user-label">New Owner</InputLabel>
                <Select
                  labelId="transfer-user-label"
                  value={transferToUser}
                  onChange={handleTransferUserChange}
                  label="New Owner"
                  disabled={transferringPhone}
                >
                  <MenuItem value="">
                    <em>Select a user</em>
                  </MenuItem>
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransferDialog} disabled={transferringPhone}>
            Cancel
          </Button>
          <Button 
            onClick={handleTransferPhoneNumber} 
            variant="contained" 
            color="primary"
            disabled={!transferToUser || transferringPhone}
          >
            {transferringPhone ? <CircularProgress size={24} /> : "Transfer"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PhoneNumbers; 